    export const headerData = {
    name: 'Dr Feten Taktak',
    title: "Médecin Tunisien",
    desciption:"Plus de 20 ans d'expérience.",
    description2:"Vous êtes le résultat de vos pensées ! ",
    image: '../../assets/png/MedPng.jpg',
}
